// extracted by mini-css-extract-plugin
export var loadingShimmer = "_s2-2";
export var messageContent = "_s2-0";
export var messagesScroll = "_s2-1";
export var shimmer = "_s2-3";
export var shimmerW100 = "_s2-4";
export var shimmerW70 = "_s2-8";
export var shimmerW80 = "_s2-7";
export var shimmerW85 = "_s2-6";
export var shimmerW90 = "_s2-5";